App.namespace.wrap('es6.views.quick_estimate.google', function (options = {}) {
  const GoogleLoginManager = App.es6.shared.google_login_manager

  const {
    googleUrl,
    googleClientId,
    csrfToken,
    callback,
    onError,
    buttonId = 'quick-estimate-submit-google',
    trackingParams,
  } = options

  const init = (initCallback) => {
    const googleLoginOptions = {
      buttonId,
      googleUrl,
      googleClientId,
      csrfToken,
      callback,
      onError,
      prompt: false,
      autoLoginOnClick: false,
      trackingParams,
    }

    return GoogleLoginManager(googleLoginOptions).init(initCallback);
  }

  return {
    init
  }
});
